import { render, staticRenderFns } from "./DianShangDialog.vue?vue&type=template&id=6968b6c1&"
import script from "./DianShangDialog.vue?vue&type=script&lang=js&"
export * from "./DianShangDialog.vue?vue&type=script&lang=js&"
import style0 from "./DianShangDialog.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports